var React = require('react');

function ChevronUpSmall (props) {
    return React.createElement("svg",props,React.createElement("g",{"data-name":"Group 111","fill":"none","stroke":"#1d252d","strokeLinecap":"round"},[React.createElement("path",{"data-name":"Line 6","d":"M14.099 4.5L7.391.682","key":0}),React.createElement("path",{"data-name":"Line 7","d":"M.683 4.5L7.391.682","key":1})]));
}

ChevronUpSmall.defaultProps = {"width":"14.78","height":"5.182"};

module.exports = ChevronUpSmall;

ChevronUpSmall.default = ChevronUpSmall;
